const Attachment = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8663 8.17422L9.10454 14.9359C7.56686 16.4736 5.07377 16.4736 3.53608 14.9359C1.99839 13.3982 1.99839 10.9052 3.53608 9.36747L10.2978 2.60576C11.3229 1.58063 12.985 1.58063 14.0101 2.60576C15.0352 3.63088 15.0352 5.29294 14.0101 6.31807L7.51356 12.8146C7.00099 13.3272 6.16996 13.3272 5.6574 12.8146C5.14484 12.302 5.14484 11.471 5.6574 10.9585L11.3584 5.25741"
      stroke="#13694E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Attachment;
